/*
    Made by : Samuel
    Date : 21
    Updated: April 23, 2025
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { useContext, useState } from "react";
import { ThemeContext } from "../../../App";
import styles from "./FAQ.module.css";

// ----------------------------------------------------------------------------- //
// COMPONENT //

function FAQ() {
    const { isDarkMode } = useContext(ThemeContext);
    const [openItems, setOpenItems] = useState(new Set([10])); // Start with first item open

    const faqItems = [
        {
            question: "Quero registar-me, como devo proceder?",
            answer: "Para te registares, preenche o formulário disponível na nossa página oficial e segue as instruções. O registo estará aberto até uma semana antes do evento.",
        },
        {
            question: "Quem pode participar?",
            answer: "O BotPombal é um evento destinado a alunos do 2º e 3º ciclos do Ensino Básico e alunos do Ensino Secundário interessados em robótica e programação.",
        },
        {
            question: "É necessário levar o meu próprio robô?",
            answer: "Não, o clube de robótica disponibiliza os robôs para as provas.",
        },
        {
            question: "As minhas faltas serão justificadas?",
            answer: "Sim, as faltas serão justificadas, apenas para os alunos do agrupamento de escolas de Pombal. Sendo da responsabilidade de cada escola a justificação das faltas.",
        },
    ];

    const toggleAccordion = (index: number) => {
        const newOpenItems = new Set(openItems);
        if (newOpenItems.has(index)) {
            newOpenItems.delete(index);
        } else {
            newOpenItems.add(index);
        }
        setOpenItems(newOpenItems);
    };

    const isItemOpen = (index: number) => openItems.has(index);

    return (
        <div className={styles.faqContainer}>
            <div className={`${styles.faqAccordion} ${isDarkMode ? styles.dark : styles.light}`} id="faqAccordion">
                {faqItems.map((item, index) => (
                    <div
                        key={`faq-${index}`}
                        className={`${styles.faqItem} ${isDarkMode ? styles.darkItem : styles.lightItem} ${
                            isItemOpen(index) ? styles.active : ""
                        }`}>
                        <h3 className={styles.faqHeader} id={`faqHeading${index}`}>
                            <button
                                className={`${styles.faqButton} ${
                                    isDarkMode ? styles.darkButton : styles.lightButton
                                } ${isItemOpen(index) ? styles.expanded : styles.collapsed}`}
                                type="button"
                                onClick={() => toggleAccordion(index)}
                                aria-expanded={isItemOpen(index)}
                                aria-controls={`faqCollapse${index}`}>
                                {item.question}
                                <span className={styles.icon}>
                                    <svg viewBox="0 0 24 24" className={styles.chevron}>
                                        <path
                                            fill="currentColor"
                                            d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                                        />
                                    </svg>
                                </span>
                            </button>
                        </h3>
                        <div
                            id={`faqCollapse${index}`}
                            className={`${styles.faqCollapse} ${isItemOpen(index) ? styles.show : ""}`}
                            aria-labelledby={`faqHeading${index}`}>
                            <div className={`${styles.faqBody} ${isDarkMode ? styles.darkBody : styles.lightBody}`}>
                                {item.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default FAQ;

// ----------------------------------------------------------------------------- //
